import { render, staticRenderFns } from "./ClientsWaitingEdit.vue?vue&type=template&id=065d0eb8&"
import script from "./ClientsWaitingEdit.vue?vue&type=script&lang=js&"
export * from "./ClientsWaitingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports